import { useEffect } from "react"
import { Outlet, Navigate, useNavigate } from "react-router-dom"
import { useAuthStore } from "@/stores/authStore"
import { LoadingSpinner } from "@/components/common/LoadingSpinner"

export default function ProtectedRoute() {
	const { isAuthenticated, isSessionVerified, verifySession } = useAuthStore()
	const navigate = useNavigate()

	useEffect(() => {
		if (!isSessionVerified) {
			verifySession().then((valid) => {
				if (!valid) navigate("/login", { replace: true })
			})
		}
	}, [isSessionVerified, verifySession, navigate])

	if (!isSessionVerified) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<LoadingSpinner size="lg" />
			</div>
		)
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />
	}

	return <Outlet />
}
